import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Select, Alert } from 'loyal-react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  fetchPointPurchaseConfiguration,
  checkoutPointsPurchase
} from 'Checkout/PointsPurchase/ducks'
import CartSummary from 'Checkout/PointsPurchase/ResumeCart/ResumeCart'
import CardFlip from 'Checkout/PointsPurchase/CardFlip'
import moment from 'moment'
import MediaQuery from 'react-responsive'

import createInstallment from 'Checkout/createInstallment'
import PointsPurchaseFormWrapper from 'Checkout/PointsPurchase/PointsPurchaseFormWrapper'

class PointsPurchaseContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      quantity: '',
      totalPrice: 0,
      selectedInstallment: { text: 'Selecione uma parcela', value: 0 },
      installmentOptions: [{ text: 'Selecione uma parcela', value: 0 }],
      cardNumber: null,
      cardExpirationDate: null,
      cardHolderName: null,
      cardCvv: null,
      isFormValid: false
    }
  }

  handleChangeInstallments = selectedInstallment => {
    this.setState({ selectedInstallment })
  }

  handleQuantityChange = e => {
    const { value } = e.target
    this.setState((state, props) => ({
      quantity: value,
      totalPrice: Math.round(this.calculateTotalPrice(props, value))
    }))
  }

  calculateTotalPrice = (props, value) => {
    let total = (value / props.config.packageSize) * props.config.price
    return total
  }

  calculateQuantity = (state, props, value) => {
    let quantity = Math.round(value / props.config.packageSize) * props.config.packageSize
    let calcTotalPrice = (quantity / props.config.packageSize) * props.config.price
    this.handleInstallmentOptions(calcTotalPrice)

    this.setState((state, props) => ({
      totalPrice: calcTotalPrice
    }))

    return quantity
  }

  handleQuantityRounding = e => {
    const { value } = e.target
    this.setState((state, props) => ({
      quantity: this.calculateQuantity(state, props, value)
    }))
  }

  handleCreditCardChange = e => {
    const { name, value } = e.target

    if (name === 'cardCvv') {
      this.handleCardCvvValidation(value)
    }

    this.setState(() => ({ [name]: value }))
  }

  handleCardNumberChange = e => {
    const cardNumber = e.target.value.replace(/\s/g, '')
    const { cardBrands } = this.props
    const cardBrand = cardBrands.find(brand =>
      RegExp(brand.regexValidation).test(cardNumber)
    )

    this.setState({ isCardNumberValid: !!cardBrand, cardBrand })
  }

  toggleCvvEditing = e => {
    this.setState({ isCardCvvEditing: e.type === 'focus' })
  }

  handleInstallmentOptions = totalPriceValue => {
    if (!totalPriceValue) return false

    if (totalPriceValue === 0) {
      return this.setState(state => ({
        installmentOptions: [state.installmentOptions[0]]
      }))
    }

    let quantityInstallment = 1
    let minimumValueInstallment = this.props.catalog.minimumInstallmentPurchasePointsCurrency

    if (totalPriceValue / 3 >= minimumValueInstallment) {
      quantityInstallment = 3
    } else if (totalPriceValue / 2 >= minimumValueInstallment) {
      quantityInstallment = 2
    }

    const installmentOptions = Array(quantityInstallment)
      .fill()
      .map((_, idx) => {
        idx++
        if (idx === 1) {
          return createInstallment(idx, totalPriceValue)
        }
        const installmentValue = (totalPriceValue / idx).toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })

        return createInstallment(idx, installmentValue)
      })

    this.setState(state => ({
      installmentOptions: [state.installmentOptions[0], ...installmentOptions]
    }))
  }

  handleExpirationDateValidation = () => {
    const { cardExpirationDate } = this.state

    const [month = '00', year = '00'] = cardExpirationDate
      ? cardExpirationDate.split('/')
      : []

    const currentYear = parseInt(moment().format('YY'))
    const currentMonth = moment().month() + 1

    const isMonthInvalid = parseInt(month) <= 0 || parseInt(month) > 12
    const isYearPast = parseInt(year) < currentYear
    const isExpired =
      parseInt(year) === currentYear && parseInt(month) < currentMonth

    this.setState({
      isCardExpirationDateValid: !isMonthInvalid && !isYearPast && !isExpired,
      cardExpirationDateMonth: month,
      cardExpirationDateYear: year
    })
  }

  handleCardHolderNameValidation = () => {
    const { cardHolderName } = this.state

    this.setState({
      isCardHolderNameValid: cardHolderName ? cardHolderName.length > 3 : false
    })
  }

  handleCardCvvValidation = value => {
    const cardCvv = value || this.state.cardCvv

    this.setState({
      isCardCvvValid: cardCvv
        ? cardCvv.length >= 3 && cardCvv.length <= 4
        : false
    })
  }

  handleCheckout = () => {
    const {
      quantity,
      cardNumber,
      cardCvv,
      cardExpirationDateMonth,
      cardExpirationDateYear,
      cardHolderName,
      selectedInstallment,
      cardBrand
    } = this.state

    const { cardHolderCpf, checkout } = this.props

    const purchase = {
      quantity: (quantity / this.props.config.packageSize),
      cardNumber: cardNumber.replace(/\s/g, ''),
      cardCvv,
      cardExpirationDateMonth,
      cardExpirationDateYear,
      cardHolderName,
      cardHolderCpf,
      installments: selectedInstallment.value,
      cardBrandId: cardBrand.id
    }

    checkout(purchase)
  }

  canCheckout = () => {
    const {
      isCardNumberValid,
      isCardHolderNameValid,
      isCardExpirationDateValid,
      isCardCvvValid,
      selectedInstallment
    } = this.state

    return (
      isCardNumberValid &&
      isCardHolderNameValid &&
      isCardExpirationDateValid &&
      isCardCvvValid &&
      selectedInstallment.value > 0
    )
  }

  componentDidMount () {
    const { loadConfiguration, isLoading } = this.props
    !isLoading && loadConfiguration()
  }

  render () {
    const {
      quantity,
      totalPrice,
      installmentOptions,
      selectedInstallment,
      cardBrand,
      cardNumber,
      cardHolderName,
      isCardHolderNameValid,
      cardExpirationDate,
      isCardExpirationDateValid,
      cardCvv,
      isCardCvvValid,
      isCardCvvEditing
    } = this.state

    const { isLoading, hasError, hasSuccess, id, errors } = this.props

    if (hasSuccess && !isLoading) {
      return <Redirect to={`/confirmation/${id}`} />
    }

    return (
      <div className='container-cart container-purchase-points-lazy container py-md-5 py-0 px-md-1 px-0'>
        <div className='row'>
          <div className='col-12'>
            {hasError &&
              errors.map(error => (
                <Alert isError title={error.message} className='pb-2' />
              ))}
          </div>
          <PointsPurchaseFormWrapper
            packageSize={this.props.config.packageSize}
          >
            <div className='col-12 col-md-6'>
              <div className='row'>
                <Input
                  type='number'
                  className='col-6 mt-0'
                  childrenClassName='no-label radius'
                  value={quantity}
                  aria-label='Quantidade'
                  name='quantity'
                  placeholder='0'
                  disabled={isLoading || hasError}
                  onChange={this.handleQuantityChange}
                  onBlur={this.handleQuantityRounding}
                />

                <Input
                  className='col-6 mt-0'
                  childrenClassName='no-label radius'
                  value={`R$ ${totalPrice}`}
                  aria-label='Valor Total'
                  disabled
                />

                <Select
                  id='payment-installment'
                  label='Parcelar em'
                  className='col-12 mt-2'
                  displayValue='text'
                  options={installmentOptions}
                  value={selectedInstallment}
                  onChange={this.handleChangeInstallments}
                  required
                  disabled={
                    isLoading || hasError || installmentOptions.length <= 1
                  }
                />

                <Input
                  id='payment-card-number'
                  label='Número do cartão'
                  aria-label='Número do cartão'
                  className='col-12 mt-2'
                  required
                  data-error={'Número de cartão inválido!'}
                  guide={false}
                  valid={this.state.isCardNumberValid}
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]}
                  name='cardNumber'
                  onChange={this.handleCreditCardChange}
                  onBlur={this.handleCardNumberChange}
                  disabled={totalPrice <= 0}
                />

                <Input
                  id='payment-card-person-name'
                  label='Nome impresso no cartão'
                  aria-label='Nome impresso no cartão'
                  className='col-12 mt-2'
                  required
                  name='cardHolderName'
                  data-error={'Nome inválido!'}
                  valid={isCardHolderNameValid}
                  value={cardHolderName}
                  onChange={this.handleCreditCardChange}
                  onBlur={this.handleCardHolderNameValidation}
                  disabled={totalPrice <= 0}
                  style={{ marginTop: '10px' }}
                />

                <Input
                  id='payment-card-validity-date'
                  label='Validade mês/ano'
                  aria-label='Validade mês/ano'
                  className='col-6 mt-2'
                  mask={[/\d/, /\d/, '/', /\d/, /\d/]}
                  required
                  name='cardExpirationDate'
                  data-error='Data inválida!'
                  valid={isCardExpirationDateValid}
                  onChange={this.handleCreditCardChange}
                  onBlur={this.handleExpirationDateValidation}
                  value={cardExpirationDate}
                  disabled={totalPrice <= 0}
                />

                <Input
                  id='payment-card-cvv'
                  label='CVV'
                  aria-label='CVV'
                  className='col-6 mt-2'
                  guide={false}
                  mask={
                    cardBrand && cardBrand.name === 'AmericanExpress'
                      ? [/\d/, /\d/, /\d/, /\d/]
                      : [/\d/, /\d/, /\d/]
                  }
                  required
                  data-error='CVV inválido!'
                  valid={isCardCvvValid}
                  value={cardCvv}
                  name='cardCvv'
                  onChange={this.handleCreditCardChange}
                  onBlur={e => {
                    this.toggleCvvEditing(e)
                    this.handleCardCvvValidation()
                  }}
                  onFocus={this.toggleCvvEditing}
                  disabled={!cardBrand}
                />
              </div>
            </div>
            <MediaQuery minDeviceWidth={1025}>
              <CardFlip
                isCardCvvEditing={isCardCvvEditing}
                cardNumber={cardNumber}
                cardBrand={cardBrand}
                cardExpirationDate={cardExpirationDate}
                cardHolderName={cardHolderName}
                cardCvv={cardCvv}
              />
            </MediaQuery>
          </PointsPurchaseFormWrapper>
          <CartSummary
            showTermsEvent={this.showTermsEvent}
            points={quantity}
            cash={totalPrice}
            canCheckout={this.canCheckout}
            purchasePointsFinaly={this.handleCheckout}
            isLoading={isLoading}
          />
        </div>
      </div>
    )
  }
}

PointsPurchaseContainer.propTypes = {
  loadConfiguration: PropTypes.func,
  isLoading: PropTypes.bool,
  config: PropTypes.object,
  cardHolderCpf: PropTypes.string,
  hasError: PropTypes.bool,
  hasSuccess: PropTypes.bool,
  errors: PropTypes.array,
  id: PropTypes.string,
  cardBrands: PropTypes.object,
  checkout: PropTypes.func,
  packageSize: PropTypes.number,
  catalog: PropTypes.object
}

const mapStateToProps = ({ pointsPurchase, cardBrands, participant, catalog }) => ({
  ...pointsPurchase,
  cardBrands: cardBrands.brands,
  cardHolderCpf: participant.cpf && participant.cpf.value,
  catalog
})

const mapDispatchToProps = dispatch => ({
  loadConfiguration: () => dispatch(fetchPointPurchaseConfiguration()),
  checkout: purchase => dispatch(checkoutPointsPurchase(purchase))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PointsPurchaseContainer)



// WEBPACK FOOTER //
// ./src/Checkout/PointsPurchase/PointsPurchaseContainer.js